type Headline1 = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const headline1: Headline1 = {
    'fontFamily': 'var(--plasma-typo-headline1-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-headline1-font-weight, 700)',
    'fontStyle': 'var(--plasma-typo-headline1-font-style, normal)',
    'fontSize': 'var(--plasma-typo-headline1-font-size, 2rem)',
    'letterSpacing': 'var(--plasma-typo-headline1-letter-spacing, -0.0110em)',
    'lineHeight': 'var(--plasma-typo-headline1-line-height, 2.25rem)'
};